module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.3c3f361.woff2";